export const alertConstants = {
    INFO: 'ALERT_INFO',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
};
